'use client'
import NavigateRightIcon from '@/app/icons/navigate-right'
import { AdDecision } from '@/app/util/ads-endpoint'
import Attribution from '@/components/attribution-v2'

import { cn } from '@/util/cn'
import { GifOverlayProps, Video, VolumeOffIcon, VolumeOnIcon } from '@giphy/react-components'
import { SyntheticEvent, useMemo, useState } from 'react'
import { spotlightWidth } from '../spotlight-grid/spotlight-util'
const GridOverlay = ({
    gif,
    data,
    muted,
    toggleMuted,
}: GifOverlayProps & { data: AdDecision; muted: boolean; toggleMuted: () => void }) => {
    const onClick = (e: SyntheticEvent) => {
        e.preventDefault()
        e.stopPropagation()
        window.open(data.cta_url, '_blank')
    }
    return (
        <div className="absolute inset-0 isolate cursor-pointer">
            {data?.cta_url && <div className="absolute inset-0" onClick={onClick} />}
            <Attribution user={gif.user} className="absolute bottom-2 left-2" />
            <div
                className="absolute right-4 top-4 cursor-pointer hover:scale-125 transition-transform"
                onClick={toggleMuted}
                role="button"
                aria-label={muted ? 'Unmute' : 'Mute'}
                aria-pressed={muted}
            >
                {muted ? <VolumeOffIcon size={32} /> : <VolumeOnIcon size={32} />}
            </div>
            {data?.cta_url && (
                <div
                    className="text-giphyWhite bg-giphyBlack absolute bottom-2 right-2 flex h-[50px] cursor-pointer items-center justify-center gap-2 rounded-md px-5 font-bold hover:underline"
                    onClick={onClick}
                >
                    {data.cta_text} <NavigateRightIcon className="fill-giphyWhite size-3" />
                </div>
            )}
        </div>
    )
}

const VideoSpotlight = ({ data, className }: { data: AdDecision; className?: string }) => {
    const { gif } = data
    const aspectRatio = gif.images.original.width / gif.images.original.height
    const [muted, setMuted] = useState(true)
    const Controls = useMemo(() => {
        const Overlay = (props: GifOverlayProps) => {
            return <GridOverlay {...props} data={data} muted={muted} toggleMuted={() => setMuted((m) => !m)} />
        }
        Overlay.displayName = 'GridOverlayControls'
        return Overlay
    }, [data, muted])
    return (
        <Video
            // eslint-disable-next-line better-tailwindcss/no-unregistered-classes
            className={cn('giphy-video-spotlight', className)}
            gif={gif}
            width={spotlightWidth}
            percentWidth="100%"
            muted={muted}
            controls
            hideAttribution
            hideMute
            hideTitle
            overlay={Controls}
            style={{ aspectRatio }}
        />
    )
}
export default VideoSpotlight
